import React, { useEffect, useRef, useState } from "react";
import DialogWrap, { DialogWrapLogin } from "../../controls/components/dialogWrap/DialogWrap";
import FomrmLogin from "./component/FormLogin";
import FomrmForgotPass from "./component/FormForgotPass";

export default function DialogForgot(props: {
	openDialog: boolean;
	setOpenDialog: (value: boolean) => void;
	setOpenDialogLogin: (value: boolean) => void;
}) {
	return (
		<DialogWrapLogin
			login={true}
			hideFooter={true}
			open={props.openDialog}
			onClose={() => {
				props.setOpenDialog(false);
			}}
			title="Forgot password">
			<FomrmForgotPass
				setOpenDialog={props.setOpenDialog}
				setOpenDialogLogin={props.setOpenDialogLogin}
			/>
		</DialogWrapLogin>
	);
}
